import React, {useState, useRef, Fragment, useEffect} from 'react';
import DataGrid, {Column} from 'devextreme-react/data-grid';
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import CardForm from './stripes/index';
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import url from '../../../../api/base-url';
import paymentApi from '../../../../api/payment';
import addressApi from '../../../../api/address';
import userApi from '../../../../api/user';
import credentials from '../../../../utils/credentials';
import ScrollView from 'devextreme-react/scroll-view';
import DropDownButton from 'devextreme-react/drop-down-button';
import {createStore} from "devextreme-aspnet-data-nojquery";
import sessions from '../../../../sessions';
import StripesListCard from './stripes-list-card/index';
import './index.scss';

const Subscriptions = () => {
    const [isCCPopUpVisible,setIsCCPopUpVisible] = useState(false);
    const [isCCListPopUpVisible,setIsCCListPopUpVisible] = useState(false);
    const [currentBalance, setCurrentBalance] = useState("$ 0");
    const [stripeCardList, setStripeCardList] = useState();
    const [stripeCustomerId, setStripeCustomerId]= useState("");
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const childRef = useRef();
    const child2Ref = useRef();

    const CCButton = {
        text: 'pay',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: () => childRef
            .current
            .onSubmit()
    };

    const CCCancelButton = {
        text: 'cancel',
        onClick: () => {
            setIsCCPopUpVisible(false);
        }
    };

    const CCListButton = {
        text: 'pay',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: () => child2Ref
            .current
            .onSubmit()
    }

    const CCListCancelButton = {
        text: 'cancel',
        onClick: () => {
            setIsCCListPopUpVisible(false);
        }
    };

    const stripesApiKey = process.env.REACT_APP_NODE_ENV === 'production'?credentials.stripe.prodApiKey:credentials.stripe.testApiKey;
    const stripePromise = loadStripe(`${stripesApiKey}`);
    const paymentLists = ['Credit Card'];
    
    function getConfig(options) {  
        options.onBeforeSend = function(method, ajaxOptions) {  
            ajaxOptions.headers = {  
               "x-access-token": auth
            }  
        }  
        return options;  
    };

    useEffect(()=>{
        (async()=>{
            await userApi.getStripeCustomerId(userId,auth).then(result=>{
                setStripeCustomerId(result.data.data)
            })
            .catch(err=>{
                console.log(err);
            })
            await paymentApi.getUserLatestBalance(userId,auth).then(result=>{
                //console.log(result.data.data);
                const currency =  addressApi.getSymbolbyCurrencyName(result.data.data.currency);
                var balance =result.data.data? `${currency} ${result.data.data.balance}`:`${currency} 0`;
                setCurrentBalance(balance);
            }).catch(err=>{
                console.log(err);
            });
            await paymentApi.stripeCardList(userId,auth).then(result=>{
                //console.log(result.data.data);
                var userCardList = result.data.data;
                setStripeCardList(userCardList.data);
            });
          })()
    },[userId]);

    const paymentDropDownOnClick = async(e) => {
        if(e.itemData === 'Credit Card'){
            if(stripeCustomerId){
                 setIsCCListPopUpVisible(true);
            }else{
                 setIsCCPopUpVisible(true);
            }
        }
     }

    const userBalance = createStore(getConfig({
        key: '_id', 
        loadUrl: `${url}/settings/userBalance/${userId}`
    }));

    const calcBalance = (data) => {
        var value = data.balance?data.balance:0;
        var curr = data?.currency?data.currency:'USD';
        var currency = addressApi.getSymbolbyCurrencyName(curr);
        return `${currency}${value}`;
    }
    const calcDebit = (data) => {
        var value = data.debit?data.debit:0;
        var curr = data?.currency?data.currency:'USD';
        var currency = addressApi.getSymbolbyCurrencyName(curr);
        return `${currency}${value}`;
    }

    const calcCredit = (data) => {
        var value = data.credit?data.credit:0;
        var curr = data?.currency?data.currency:'USD';
        var currency = addressApi.getSymbolbyCurrencyName(curr);
        return `${currency}${value}`;
    }

    return (
        <Fragment>
            <Popup
                title={`Pay with Card`}
                visible={isCCPopUpVisible}
                width={'55vw'}
                height={'80vh'}
                onHiding={e => {setIsCCPopUpVisible(false)}}>
                <Elements stripe={stripePromise}>
                    <ScrollView><CardForm ref={childRef}/></ScrollView>
                </Elements>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={CCButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={CCCancelButton}></ToolbarItem>
            </Popup>
            <Popup
                title={`Your Cards`}
                visible={isCCListPopUpVisible}
                width={'55vw'}
                height={'80vh'}
                onHiding={e => {setIsCCListPopUpVisible(false)}}>
                    <ScrollView><StripesListCard data={stripeCardList} ref={child2Ref}/></ScrollView>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={CCListButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={CCListCancelButton}></ToolbarItem>
            </Popup>
            <h4 className={'content-block'}>Manage Subscriptions</h4>
            <div className={'subscriptions content-block'}>
                <p className={'disclaimer'}><i className="fas fa-info-circle"></i> ShipsLand offer international Payment through Credit Card</p>
                <div className={'flex flex-row space-between'}>
                    <div className={'payment-btn'}>
                        <DropDownButton
                            items={paymentLists}
                            className={'mr-2'}
                            text={'Add Funds'}
                            stylingMode={'contained'}
                            type={'default'}
                            onItemClick={paymentDropDownOnClick}
                            />
                    </div>
                    <div className={'current-balance'}>
                       <h5>Current Balance: <b>{currentBalance}</b></h5>
                    </div>
                </div>
                <DataGrid
                    dataSource={userBalance}
                    showBorders={false}
                    focusedRowEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    columnHidingEnabled={true}
                    wordWrapEnabled={true}>
                    <Column editorType={'dxTextBox'} dataField={'date'} dataType="date"/>
                    <Column editorType={'dxTextBox'} dataField={'balance'} calculateCellValue={calcBalance}/>
                    <Column editorType={'dxTextBox'} dataField={'debit'} calculateCellValue={calcDebit}/>
                    <Column editorType={'dxTextBox'} dataField={'credit'} calculateCellValue={calcCredit}/>
                    <Column editorType={'dxTextBox'} dataField={'notes'}/>
                </DataGrid>
            </div>
        </Fragment>
    );
}
export default Subscriptions;